import { render, staticRenderFns } from "./mobile-login-icon.vue?vue&type=template&id=60cb2b02&scoped=true&lang=pug&"
import script from "./mobile-login-icon.vue?vue&type=script&lang=js&"
export * from "./mobile-login-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cb2b02",
  null
  
)

export default component.exports